import { render, staticRenderFns } from "./PageNotificationsView.vue?vue&type=template&id=d5a6c7fe&"
import script from "./PageNotificationsView.vue?vue&type=script&lang=ts&"
export * from "./PageNotificationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports